import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useLoading } from '../providers/loading'
import Button from '../components/button'
import Select from '../components/select'
import diagramApi from '../api/diagram'

const FILTER_TYPES = {
  engine_type: 'engine_type',
  engine_power: 'engine_power',
  model: 'model',
  year: 'year',
  category: 'category'
}

const FILTER_ORDER = [
  FILTER_TYPES.engine_type,
  FILTER_TYPES.engine_power,
  FILTER_TYPES.model,
  FILTER_TYPES.year,
  FILTER_TYPES.category
]

const FILTER_TYPE_NAMES = {
  [FILTER_TYPES.engine_type]: 'Type',
  [FILTER_TYPES.engine_power]: 'Engine',
  [FILTER_TYPES.model]: 'Model',
  [FILTER_TYPES.year]: 'Year',
  [FILTER_TYPES.category]: 'Diagram'
}

const SearchPage = ({ showHeading = true, screenHeight = true }) => {
  const { setIsLoading } = useLoading()
  const navigate = useNavigate()

  const [options, setOptions] = useState({
    [FILTER_TYPES.engine_type]: [],
    [FILTER_TYPES.engine_power]: [],
    [FILTER_TYPES.model]: [],
    [FILTER_TYPES.year]: [],
    [FILTER_TYPES.category]: []
  })

  const [selections, setSelections] = useState({
    [FILTER_TYPES.engine_type]: null,
    [FILTER_TYPES.engine_power]: null,
    [FILTER_TYPES.model]: null,
    [FILTER_TYPES.year]: null,
    [FILTER_TYPES.category]: null
  })

  const formatOptions = (data, type) => {
    switch (type) {
      case FILTER_TYPES.engine_type:
      case FILTER_TYPES.model:
        return data.map(item => ({
          label: item.name,
          value: item._id
        }))
      case FILTER_TYPES.engine_power:
        return data.map(item => ({
          label: item,
          value: item
        }))
      case FILTER_TYPES.year:
        return data.map(item => ({
          label: `${item}`,
          value: item
        }))
      case FILTER_TYPES.category:
        return [
          { label: 'All Diagrams', value: 'all' },
          ...data.map(item => ({
            label: item.name,
            value: item._id
          }))
        ]
      default:
        return []
    }
  }

  const fetchData = async (filters = {}) => {
    setIsLoading(true)

    try {
      const response = await diagramApi.getAll(filters)

      if (response?.success && response.data) {
        const data = response.data

        setOptions(prev => ({
          ...prev,
          [FILTER_TYPES.engine_type]: formatOptions(data.engine_type, FILTER_TYPES.engine_type),
          [FILTER_TYPES.engine_power]: formatOptions(data.engine_power, FILTER_TYPES.engine_power),
          [FILTER_TYPES.model]: formatOptions(data.models, FILTER_TYPES.model),
          [FILTER_TYPES.year]: formatOptions(data.years, FILTER_TYPES.year),
          [FILTER_TYPES.category]: formatOptions(data.category, FILTER_TYPES.category)
        }))
      }
    } catch (error) {
      console.error('Error fetching data:', error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleSelectChange = (type, value) => {
    const currentIndex = FILTER_ORDER.indexOf(type)

    const newSelections = { ...selections }
    newSelections[type] = value

    FILTER_ORDER.forEach((filterType, index) => {
      if (index > currentIndex) {
        newSelections[filterType] = null
      }
    })

    setSelections(newSelections)

    setOptions(prev => {
      const newOptions = { ...prev }

      FILTER_ORDER.forEach((filterType, index) => {
        if (index > currentIndex) {
          newOptions[filterType] = []
        }
      })

      return newOptions
    })

    const apiFilters = {}

    FILTER_ORDER.forEach((filterType, index) => {
      if (index <= currentIndex && newSelections[filterType]) {
        apiFilters[filterType] = newSelections[filterType]
      }
    })

    fetchData(apiFilters)
  }

  const handleSearch = () => {
    const searchParams = new URLSearchParams()

    Object.entries(selections).forEach(([key, value]) => {
      if (value) {
        searchParams.append(key, value)
      }
    })

    if (selections.category === 'all') {
      window.parent.postMessage({
        'action': 'redirect',
        'data': {
          'url': '/diagrams',
          'search': searchParams.toString()
        }
      }, '*');
      // navigate({
      //   pathname: '/diagrams',
      //   search: searchParams.toString()
      // })
    } else {
      window.parent.postMessage({
        'action': 'redirect',
        'data': {
          'url': '/diagram',
          'search': searchParams.toString()
        }
      }, '*');
      // navigate({
      //   pathname: '/diagram',
      //   search: searchParams.toString()
      // })
    }

    // window.location.reload()
  }

  useEffect(() => {
    fetchData()
  }, [])

  useEffect(() => {
    window.parent.postMessage({
      'frameHeight': document.body.scrollHeight
    }, '*')
  }, [])

  return (
    <div className={`flex flex-col gap-7 py-5 items-center justify-center ${screenHeight ? 'h-screen' : ''} px-10`}>
      {showHeading && (
        <div className='text-[#062743] text-4xl font-normal title text-center'>
          BROWSE DIAGRAMS BY ENGINE
        </div>
      )}
      <div className='flex gap-5 flex-wrap'>
        {FILTER_ORDER.map((type, index) => (
          <Select
            key={type}
            options={options[type]}
            onChange={(value) => handleSelectChange(type, value)}
            value={selections[type]}
            placeholder={`Select ${FILTER_TYPE_NAMES[type]}`}
            disabled={index > 0 && !selections[FILTER_ORDER[index - 1]]}
          />
        ))}
      </div>
      <Button 
        text='Search' 
        onClick={handleSearch}
        disabled={!FILTER_ORDER.every(type => selections[type])}
      />
    </div>
  )
}

export default SearchPage